module.exports = __webpack_public_path__ + "static/media/pledge.47c02f3a.svg";